import React from 'react';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["SEEN"] = "Seen";
  TabHeaders["IN_PRINT"] = "In print";
  TabHeaders["ONLINE"] = "Website";
  TabHeaders["ONLINE_DATABASE"] = "Online database";
})(TabHeaders || (TabHeaders = {}));
export var PaintingContributors;

/** painting title and testIds */
(function (PaintingContributors) {
  PaintingContributors["Artist"] = "Artist";
  PaintingContributors["SOURCE_AUTHOR"] = "Source author";
  PaintingContributors["SOURCE_EDITOR"] = "Source editor";
  PaintingContributors["SOURCE_COMPILER"] = "Source compiler";
  PaintingContributors["SOURCE_TRANSLATOR"] = "Source translator";
})(PaintingContributors || (PaintingContributors = {}));
export var PAINTING_TITLE_INPUT_LABEL = 'Painting title';
export var PAINTING_TITLE_INPUT_TEST_ID = 'painting-title-input-test-id';
export var PAINTING_DESCRIPTION_INPUT_LABEL = 'Description';
export var PAINTING_DESCRIPTION_INPUT_TEST_ID = 'description-input-test-id';
export var PAINTING_COLLECTION_INPUT_LABEL = 'Collection';
export var PAINTING_COLLECTION_INPUT_TEST_ID = 'collection-input-test-id';
export var PAINTING_MUSEUM_INPUT_LABEL = 'Museum';
export var PAINTING_MUSEUM_INPUT_TEST_ID = 'museum-input-test-id';
export var PAINTING_LOCATION_INPUT_LABEL = 'Location';
export var PAINTING_LOCATION_INPUT_TEST_ID = 'location-input-test-id';
export var PAINTING_YEAR_INPUT_LABEL = 'Year created';
export var PAINTING_YEAR_INPUT_TEST_ID = 'year-input-test-id';
export var PaintingContributorRoleOptions = [{
  uuid: FunctionTypes.ARTIST,
  value: FunctionTypes.ARTIST,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PaintingContributors.Artist)
}, {
  uuid: FunctionTypes.AUTHOR,
  value: FunctionTypes.AUTHOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PaintingContributors.SOURCE_AUTHOR)
}, {
  uuid: FunctionTypes.EDITOR,
  value: FunctionTypes.EDITOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PaintingContributors.SOURCE_EDITOR)
}, {
  uuid: FunctionTypes.COMPILER,
  value: FunctionTypes.COMPILER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PaintingContributors.SOURCE_COMPILER)
}, {
  uuid: FunctionTypes.TRANSLATOR,
  value: FunctionTypes.TRANSLATOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PaintingContributors.SOURCE_TRANSLATOR)
}];